import React, { useState } from "react";
import AdminClient from "../../services/dashboard/AdminClient";
import toast from "react-hot-toast";

export default function AssignRolesModal({ admin, roles = [], onClose }) {
  const initial = new Set((admin.roles || []).map((r) => r.name));
  const [selected, setSelected] = useState(initial);
  const [saving, setSaving] = useState(false);

  function toggle(roleName) {
    const s = new Set(selected);
    if (s.has(roleName)) s.delete(roleName);
    else s.add(roleName);
    setSelected(s);
  }

  function save() {
    setSaving(true);
    const roleList = Array.from(selected);
    AdminClient.replaceRoles(admin.adminId, roleList)
      .then((res) => {
        toast.success("Roles updated");
        // assume backend returns updated AdminDTO in response.data.responseData
        const updated = res.data?.responseData ?? res.data ?? res;
        onClose(updated); // pass updated for callers to update redux if needed
      })
      .catch((err) => {
        console.error(err);
        toast.error("Failed to update roles");
      })
      .finally(() => setSaving(false));
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
      <div className="bg-white p-6 rounded w-96">
        <h3 className="text-lg mb-4">Assign Roles - {admin.username}</h3>
        <div className="space-y-2 mb-4">
          {roles.map((r) => (
            <label key={r.id} className="flex items-center gap-2">
              <input type="checkbox" checked={selected.has(r.name)} onChange={() => toggle(r.name)} />
              <span>{r.name} <small className="text-gray-500 ml-2">({r.description})</small></span>
            </label>
          ))}
        </div>

        <div className="flex justify-end gap-2">
          <button onClick={() => onClose(null)} className="btn">Cancel</button>
          <button onClick={save} className="btn btn-primary" disabled={saving}>
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
